import Vue from 'vue'
import Router from 'vue-router'

import MainLayout from '@/components/Layout/Main'

// import Home from '@/components/Home'
import ShopSelect from '@/components/ShopSelect/Index'

import Dashboard from '@/components/Dashboard/Index'
import Login from '@/components/Login'
import TokenLogin from '@/components/TokenLogin'

import ReportSalesBudget from '@/components/Report/SalesBudget'
import ReportDaily from '@/components/Report/Daily'
import ReportSalesItem from '@/components/Report/ReportSalesItem'
import ReportSalesPayment from '@/components/Report/ReportSalesPayment'
import ReportSalesCategory from '@/components/Report/ReportSalesCategory'
import ReportPaymentAnalyze from '@/components/Report/PaymentAnalyze'
import ReportPaymentTime from '@/components/Report/PaymentTime'
import ReportSalesAnalyze from '@/components/Report/ReportSalesAnalyze'
import ReportSalesWeekday from '@/components/Report/ReportSalesWeekday'
import ReportSalesStaff from '@/components/Report/ReportSalesStaff'
import ReportCashNote from '@/components/Report/ReportCashNote'
import ReportAudit from '@/components/Report/ReportAudit'
import TimeSetting from '@/components/TimeSetting/Index'
import Category from '@/components/Category/Index'
import Department from '@/components/Department/Index'
import Settings from '@/components/Report/Settings'
import ReportShopPaymentNote from '@/components/Report/ShopPaymentNote'
import ReportShopSalesAnalyze from '@/components/Report/ReportShopSalesAnalyze'
import ReportSalesMonth from '@/components/Report/ReportSalesMonth'
import ReportShopMenuSales from '@/components/Report/ReportShopMenuSales'

import NotFound from '@/components/exceptions/NotFound'

Vue.use(Router)

const children = [
  {
    path: '/shop-select',
    name: 'ShopSelect',
    component: ShopSelect,
    partial: false,
    meta: {agencyOnly: true},
  },
  {
    path: '/',
    name: 'Home',
    component: Dashboard,
    partial: false,
  },
  {
    path: '/report/sales-budget',
    name: 'ReportSalesBudget',
    component: ReportSalesBudget,
    partial: false,
    meta: {title: '予算入力'},
  },
  {
    path: '/report/daily',
    name: 'ReportDaily',
    component: ReportDaily,
    partial: false,
    meta: {title: '日報'},
  },
  {
    path: '/report/sales-item',
    name: 'ReportSalesItem',
    component: ReportSalesItem,
    partial: false,
    meta: {title: '商品別売上'},
  },
  {
    path: '/report/sales-payment',
    name: 'ReportSalesPayment',
    component: ReportSalesPayment,
    partial: false,
    meta: {title: '支払別売上'},
  },
  {
    path: '/report/sales-category',
    name: 'ReportSalesCategory',
    component: ReportSalesCategory,
    partial: false,
    meta: {title: 'カテゴリー別売上'},
  },
  {
    path: '/report/payment-analyze',
    name: 'ReportPaymentAnalyze',
    component: ReportPaymentAnalyze,
    partial: false,
    meta: {title: '支払管理票'},
  },
  {
    path: '/report/payment-time',
    name: 'ReportPaymentTime',
    component: ReportPaymentTime,
    partial: false,
    meta: {title: '時間売上'},
  },
  {
    path: '/report/sales-weekday',
    name: 'ReportSalesWeekday',
    component: ReportSalesWeekday,
    partial: false,
    meta: {title: '曜日売上'},
  },
  {
    path: '/report/sales-analyze',
    name: 'ReportSalesAnalyze',
    component: ReportSalesAnalyze,
    partial: false,
    meta: {title: '売上分析'},
  },
  {
    path: '/report/sales-staff',
    name: 'ReportSalesStaff',
    component: ReportSalesStaff,
    partial: false,
    meta: {title: '担当者別売上'},
  },
  {
    path: '/report/cash-note',
    name: 'ReportCashNote',
    component: ReportCashNote,
    partial: false,
    meta: {title: '現金管理票'},
  },
  {
    path: '/report/audit',
    name: 'ReportAudit',
    component: ReportAudit,
    partial: false,
    meta: {title: '監査レポート'},
  },
  {
    path: '/time-setting',
    name: 'TimeSetting',
    component: TimeSetting,
    partial: false,
    meta: {title: '時間帯設定'},
  },
  {
    path: '/category',
    name: 'Category',
    component: Category,
    partial: false,
    meta: {title: 'カテゴリー'},
  },
  {
    path: '/department',
    name: 'Department',
    component: Department,
    meta: {title: '部門'},
    partial: false,
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    partial: false,
    meta: {title: '設定'},
  },
  {
    path: '/report/shop-payment-note',
    name: 'ReportShopPaymentNote',
    component: ReportShopPaymentNote,
    partial: false,
    meta: {title: '店舗別支払管理'},
  },
  {
    path: '/report/shop-sales-analyze',
    name: 'ReportShopSalesAnalyze',
    component: ReportShopSalesAnalyze,
    partial: false,
    meta: {title: '店舗別売上分析'},
  },
  {
    path: '/report/sales-month',
    name: 'ReportSalesMonth',
    component: ReportSalesMonth,
    partial: false,
    meta: {title: '月別売上分析'},
  },

  {
    path: '/report/shop-menu-sales',
    name: 'ReportShopMenuSales',
    component: ReportShopMenuSales,
    partial: false,
    meta: {title: '店舗別メニュー売上'},
  },
]

export default new Router({
  mode: 'history',
  linkActiveClass: 'current',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      partial: false,
      meta: {publicPage: true},
    },
    {
      path: '/login/:token/',
      name: 'TokenLogin',
      component: TokenLogin,
      props: true,
      meta: { publicPage: true },
    },
    {
      path: '/',
      partial: false,
      component: MainLayout,
      children: children,
    },
    {
      path: '*',
      name: '404',
      component: NotFound,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js